import styled from "styled-components";

export const Box = styled.div`
  .container {
    max-width: 1400px;
    margin: 20px auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  .title {
    text-align: center;
    margin-bottom: 20px;
  }

  .input {
    // border: 2px solid red; /* Red border like in the image */
    width: 100%;
    padding: 8px;
    border-radius: 4px;
  }

  .submitButton {
    width: 100%;
    font-weight: bold;
    background-color: #f0a500; /* Orange color */
    border: none;
    padding: 8px 16px;
    margin-right: 10px;
  }

  .submitButton:hover {
    background-color: #e08f00;
  }

  .status {
    margin-top: 20px;
    font-size: 14px;
  }

  .disclaimer {
    color: #dc3545; /* Red color for warning */
    font-style: italic;
    margin-top: 10px;
  }

  .link {
    color: #007bff;
    text-decoration: underline;
  }

  .table {
    margin-top: 20px;
  }

  .table th {
    background-color: #f2f2f2;
    padding: 10px;
  }

  .table td {
    vertical-align: middle;
    padding: 8px;
  }

  .pauseButton {
    background-color: #f4a261;
    border: none;
    padding: 8px 16px;
  }

  .status {
    margin-top: 10px;
    padding: 10px;
    font-size: 14px;
    background-color: #f9f9f9;
    border-radius: 4px;
  }

  .status p {
    margin: 5px 0;
  }

  .checking {
    color: green;
    background-color: #fff3cd;
  }

  .broken {
    background-color: #f8d7da;
    color: red;
  }

  .broken a {
    color: red !important;
  }
`;
